import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProjectItemWithSelectionComponent } from "./project-item-withselection.component";

@Component({
    selector: 'production-office',
    template: require('./production-office.component.html')
})
export class ProductionOfficeComponent extends ProjectItemWithSelectionComponent {
    
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/production-office.component.ts